import { colors, fonts } from '../../theme';

const linkColor = '#C9C9C9';

const styles = {
  root: {
    px: 1.25,
    pt: 1.5,
    borderTop: `1px solid ${colors.border}`,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  socials: {
    display: 'flex',
    gap: 1.5,
    mb: 0.5,
  },
  social: {
    display: 'flex',
    color: linkColor,
    fontSize: 14,
    '&:hover': {
      color: colors.text,
    },
  },
  legal: {
    m: 0,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    fontFamily: fonts.text,
    fontSize: 11,
    lineHeight: 1.5,
    color: colors.textSubtle,
  },
  link: {
    color: linkColor,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: colors.text,
    },
  },
  sep: {
    mx: '5px',
    color: '#6B6B6B',
  },
  copy: {
    m: 0,
    fontFamily: fonts.text,
    fontSize: 11,
    lineHeight: 1.5,
    color: colors.textSubtle,
  },
};

export default styles;
